// Neural S Logo Component - Shared across the app
export const NeuralLogo = ({ size = 32, className = "" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 1024 1024" 
    className={className}
  >
    <defs>
      <linearGradient id="neuralGradientShared" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#22D3EE" />
        <stop offset="100%" stopColor="#A855F7" />
      </linearGradient>
      <filter id="glowShared">
        <feGaussianBlur stdDeviation="8" result="coloredBlur"/>
        <feMerge>
          <feMergeNode in="coloredBlur"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>
    </defs>
    <rect width="1024" height="1024" rx="230" fill="#0F172A"/>
    <path 
      d="M680 280 C680 280 720 350 650 420 C580 490 380 520 340 600 C300 680 350 750 450 750 C550 750 620 700 620 700" 
      fill="none" 
      stroke="url(#neuralGradientShared)" 
      strokeWidth="52" 
      strokeLinecap="round"
      filter="url(#glowShared)"
    />
    <path 
      d="M680 280 C680 280 720 350 650 420 C580 490 380 520 340 600 C300 680 350 750 450 750 C550 750 620 700 620 700" 
      fill="none" 
      stroke="white" 
      strokeWidth="8" 
      strokeLinecap="round"
      opacity="0.6"
    />
    <circle cx="680" cy="280" r="16" fill="#22D3EE" filter="url(#glowShared)"/>
    <circle cx="650" cy="420" r="12" fill="#6EE7B7" filter="url(#glowShared)"/>
    <circle cx="340" cy="600" r="12" fill="#A855F7" filter="url(#glowShared)"/>
    <circle cx="620" cy="700" r="16" fill="#A855F7" filter="url(#glowShared)"/>
  </svg>
);
